import React, { createContext, useContext, useState } from 'react';
import ConfirmationDialog from '../components/ConfirmationDialog';

const DialogContext = createContext();

export const useDialog = () => useContext(DialogContext);

const DialogProvider = ({ children }) => {
  const [dialogConfig, setDialogConfig] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    confirmText: '确定', 
    cancelText: '取消',
    showConfirmButton: true,
    showCancelButton: true,
  });

  const openDialog = (config) => {
    setDialogConfig((prevConfig) => ({
      ...prevConfig,
      open: true,
      title: config.title || prevConfig.title, 
      message: config.message || prevConfig.message, 
      onConfirm: config.onConfirm || prevConfig.onConfirm, 
      confirmText: config.confirmText || '确定', 
      cancelText: config.cancelText || '取消', 
      showConfirmButton: config.showConfirmButton !== undefined ? config.showConfirmButton : true, // Default to true
      showCancelButton: config.showCancelButton !== undefined ? config.showCancelButton : true, // Default to true
    }));
  };

  const closeDialog = () => {
    setDialogConfig((prevConfig) => ({ ...prevConfig, open: false }));
  };

  return (
    <DialogContext.Provider value={{ openDialog, closeDialog, dialogConfig }}>
      {children}
      <ConfirmationDialog
        open={dialogConfig.open}
        title={dialogConfig.title}
        message={dialogConfig.message}
        onConfirm={() => {
          if (dialogConfig.onConfirm) dialogConfig.onConfirm();
          closeDialog();
        }}
        onClose={closeDialog}
        confirmText = {dialogConfig.confirmText}
        cancelText = {dialogConfig.cancelText}
        showConfirmButton={dialogConfig.showConfirmButton}
        showCancelButton={dialogConfig.showCancelButton}
      />
    </DialogContext.Provider>
  );
};

export default DialogProvider;
